import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { TimeOffApprovalStateClass } from './interfaces/TimeOffApprovalStateClass'
import { useAppSelector } from '../../../app/hooks';
import moment from 'moment';

const initialState: TimeOffApprovalStateClass = {
    isLoading: false,
    status: 'idle',
    timeOffApprovalList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    currentpageApproved :1,
    pageSize: 8,
    pagesizeApproved:10,
    totalItems: 0,
    totalItemsApproved :0,
    start: 0,
    startApproved:0,
    search: " ",
    searchApproved:" ",
    recordsFiltered: 0,
    recordsFilteredApproved : 0,
    timeOffApprovalCheckedIds: [],
    isAllUnChecked: true,
    optionTimeOffTypesValue: "00000000-0000-0000-0000-000000000000",
    optionTimeOffTypesText: "All",
    optionApproverEmployeeValue: "0",
    optionApproverEmployeeText: "All",
    optionProjectValue: "0",
    optionProjectText: "All",
    optionProjectTaskValue: "0",
    optionProjectTaskText: "All",
    optionApprovedValue: "-1",
    optionApprovedText: "Both",
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    timeOffTypesList: [],
    approverEmployeeList: [],
    timeOffApprovedList:[],
    isTimeOffApprovaltab:true
}

interface IThunkApi {
    state: {
        timeOffApproval: TimeOffApprovalStateClass;
    },
}

// export const getAllTimeOffApprovalEntriesAsync = createAsyncThunk
//     <any, any, IThunkApi>
//     (
//         'TimeOffs/V2/getAllTimeOffApprovalEntries',
//         async (arg, thunkApi) => {
//             const { AccountTimeOffTypeId, TimeOffAccountEmployeeId, IncludeDateRange, StartDate, EndDate } = arg;
//             const response = await fetchAPI('api/V2/TimeOffs/TimeOffApprovalEntries/' + AccountTimeOffTypeId + '/' + TimeOffAccountEmployeeId + '/' + IncludeDateRange + '/' + StartDate + '/' + EndDate, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
//             const json = await response.json();
//             return json;
//         }
//     )
export const getAllTimeOffApprovalEntriesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffs/V2/GetAccountTimeOffRequestApprovalEntriesPending',
        async (arg, thunkApi) => {
            const { AccountTimeOffTypeId, TimeOffAccountEmployeeId, IncludeDateRange, StartDate, EndDate } = arg;
            const response = await fetchAPI('api/V2/TimeOffs/GetAccountTimeOffRequestApprovalEntriesPending/' + AccountTimeOffTypeId + '/' + TimeOffAccountEmployeeId + '/' + IncludeDateRange + '/' + StartDate + '/' + EndDate, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )


    export const getAllTimeOffApprovedEntriesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TimeOffs/V2/getAllTimeOffApprovedEntries',
        async (arg, thunkApi) => {
            const { AccountTimeOffTypeId, TimeOffAccountEmployeeId, IncludeDateRange, StartDate, EndDate } = arg;
            const response = await fetchAPI('api/V2/TimeOffs/GetAccountEmployeeTimeOffApprovedEntries/' + AccountTimeOffTypeId + '/' + TimeOffAccountEmployeeId + '/' + IncludeDateRange + '/' + StartDate + '/' + EndDate, 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            console.log('response data', json);
            return json;
        }
    )

export const getAccountTimeOffTypesByAccountIdAndIsDisabledAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'TimeOffs/V2/getAccountTimeOffTypesByAccountIdAndIsDisabled',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/TimeOffs/TimeOffTypes', 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const getEmployeesForTimeOffApprovalAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'TimeOffs/V2/getEmployeesForTimeOffApproval',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/TimeOffs/ApproverEmployee', 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const addTimeOffApprovalsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffs/v2/addTimeOffApprovals",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/TimeOffs/AddTimeOffApprovals", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const ApproveSelectedAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffs/v2/ApproveSelected",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/TimeOffs/ApproveSelected", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const SingleApproveAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffs/v2/SingleApprove",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/TimeOffs/SingleApprove", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const RejectSelectedAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffs/v2/RejectSelected",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/TimeOffs/RejectSelected", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const SingleRejectAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TimeOffs/v2/SingleReject",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/TimeOffs/SingleReject", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const timeOffApprovalSlice = createSlice({
    name: 'timeEntryArchive',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.timeOffApprovalList = [];
            state.timeOffApprovalCheckedIds = [];
        },
        checkedState: (state, action) => {
            const currentindex = state.timeOffApprovalList.findIndex((item) => item.AccountEmployeeTimeOffRequestId == action.payload);
            const newArray = [...state.timeOffApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1, 'Approved': true, 'Rejected': true };
            state.timeOffApprovalList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.timeOffApprovalList.findIndex((item) => item.AccountEmployeeTimeOffRequestId == action.payload);
            const newArray = [...state.timeOffApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0, 'Approved': false, 'Rejected': false };
            state.timeOffApprovalList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.timeOffApprovalList.map((item) => ({
                ...item,
                isSelected: 1,
                'Approved': true,
                'Rejected': true
            }));
            state.timeOffApprovalList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.timeOffApprovalList.map((item) => ({
                ...item,
                isSelected: 0,
                'Approved': false,
                'Rejected': false
            }));
            state.timeOffApprovalList = newArray;
        },
        setOptionTimeOffTypesValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionTimeOffTypesValue = value;
            state.optionTimeOffTypesText = label;
        },
        setOptionApproverEmployeeValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionApproverEmployeeValue = value;
            state.optionApproverEmployeeText = label;
        },
        setOptionProjectValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectValue = value;
            state.optionProjectText = label;
        },
        setOptionProjectTaskValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectTaskValue = value;
            state.optionProjectTaskText = label;
        },
        setOptionApprovedValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionApprovedValue = value;
            state.optionApprovedText = label;
        },
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        setComments: (state, action) => {
            const { Comments, AccountEmployeeTimeOffRequestId } = action.payload;
            const currentindex = state.timeOffApprovalList.findIndex((item) => item.AccountEmployeeTimeOffRequestId == AccountEmployeeTimeOffRequestId);
            const newArray = [...state.timeOffApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], Comments: Comments };
            state.timeOffApprovalList = newArray;
        },
        filterTimeOffApproval: (state, action) => {
            const { AccountTimeOffTypeId, TimeOffAccountEmployeeId, IncludeDateRange, StartDate, EndDate, AccountEmployeeId } = action.payload;
            const newArray = [...state.timeOffApprovalList];
            newArray.forEach((item: any) => {
                if (
                    (TimeOffAccountEmployeeId != 0 ? (item.TimeOffAccountEmployeeId == TimeOffAccountEmployeeId) : true) &&
                    (AccountTimeOffTypeId != 0 ? (item.AccountTimeOffTypeId == AccountTimeOffTypeId) : true) && // Use single quotes around the GUID
                    (IncludeDateRange ? (moment(item.StartDate).format('MM-DD-YYYY') >= StartDate && moment(item.EndDate).format('MM-DD-YYYY') <= EndDate) : true) &&
                    item.AccountEmployeeId == AccountEmployeeId
                ) {
                    item.isFiltered = 1;
                }
                else {
                    item.isFiltered = 0;
                }
            });
           
            state.timeOffApprovalList = newArray;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },

        updateisTimeOffApprovaltab: (state, action: PayloadAction<boolean>) => {
            state.isTimeOffApprovaltab = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllTimeOffApprovalEntriesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAllTimeOffApprovalEntriesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.timeOffApprovalList = [];
                } else {
                    state.timeOffApprovalList = payload.Data;
                    state.timeOffApprovalList.map((item: any) => {
                        item.isSelected = 0
                        item.isFiltered = -1;
                        item.approvedButtonClass = 'btn-light-success btn-sm';
                        item.rejectedButtonClass = 'btn-light-danger btn-sm';
                        if (!item.hasOwnProperty('Comments')) {
                            item.Comments = "";
                        }
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
                //state.start = payload.start
                // state.currentPage = payload.currentPage;
                // state.totalItems = payload.recordsTotal;
                // state.search = payload.search;
                // state.recordsFiltered = payload.recordsFiltered;
            })
            .addCase(getAllTimeOffApprovalEntriesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false
                state.isReload = false;
            })

            .addCase(getAllTimeOffApprovedEntriesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAllTimeOffApprovedEntriesAsync.fulfilled, (state, { payload }) => {
                console.log('payload',payload)
               state.status = 'idle';
                if (Object.keys(payload).length === 0) {
                    state.timeOffApprovedList = [];
                } else {
                    state.timeOffApprovedList = payload;
                }
                state.isReload = false;
                state.isLoading = false;
            
            })
            .addCase(getAllTimeOffApprovedEntriesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false
                state.isReload = false;
            })


            .addCase(getAccountTimeOffTypesByAccountIdAndIsDisabledAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = false
            })
            .addCase(getAccountTimeOffTypesByAccountIdAndIsDisabledAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                payload.Data.map((item: any) => {
                    item.value = item.AccountTimeOffTypeId;
                    item.label = item.AccountTimeOffType;
                });
                payload.Data.unshift({ value: '0', label: 'All' })
                state.timeOffTypesList = payload.Data;
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(getAccountTimeOffTypesByAccountIdAndIsDisabledAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false
            })
            .addCase(getEmployeesForTimeOffApprovalAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = false
            })
            .addCase(getEmployeesForTimeOffApprovalAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(getEmployeesForTimeOffApprovalAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false
            })
            .addCase(addTimeOffApprovalsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addTimeOffApprovalsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addTimeOffApprovalsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(ApproveSelectedAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(ApproveSelectedAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(ApproveSelectedAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(RejectSelectedAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(RejectSelectedAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(RejectSelectedAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(SingleApproveAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(SingleApproveAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(SingleApproveAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(SingleRejectAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(SingleRejectAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(SingleRejectAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const {
    resetSelectedRecordObjectInState,
    setOptionApprovedValue, setOptionTimeOffTypesValue, setOptionApproverEmployeeValue, setOptionProjectTaskValue, setOptionProjectValue, setDateRangeValue, setComments,
    filterTimeOffApproval, checkedState, unCheckedState, checkedAllState, unCheckedAllState, updateIsLoading, updateisTimeOffApprovaltab
} = timeOffApprovalSlice.actions
export const TimeOffApprovalState = (state: RootState) => state.timeOffApproval
export default timeOffApprovalSlice.reducer
